import { put, select, takeLatest } from 'redux-saga/effects'
import { getAddMedicationAdministeredSelector } from '../selectors'
import { setAddMedicationAdministeredData } from '../store/addMedicationAdministered.actions'
import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'
import { updateCustomGroupsFromTimeLine } from '../../nemsisData/store/nemsisCustomData.actions'
import { StateCustomDataConstants } from '../../nemsisData/store/nemsisCustomData.constants'

export function* deleteMedicationAdministered() {
  const medicationAdministeredState: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const { medicationAdministered, addMedicationAdministeredData } = medicationAdministeredState
  if (medicationAdministered && addMedicationAdministeredData) {
    yield put(
      setAddMedicationAdministeredData(
        addMedicationAdministeredData.filter(
          (medicationAdministeredInfo) => medicationAdministered.key !== medicationAdministeredInfo?.key
        )
      )
    )
    yield put(
      updateCustomGroupsFromTimeLine(StateCustomDataConstants.REMOVE_MEDICATION_GROUP, medicationAdministered.key)
    )
  }
}
export function* deleteMedicationAdministeredSaga() {
  yield takeLatest([AddMedicationAdministeredConstants.DELETE_MEDICATION_ADMINISTERED], deleteMedicationAdministered)
}
